module.exports = __webpack_public_path__ + "assets/img/news_img1.ac7b0dae.png";